import store from "./store";
import {uuid} from "../@types/schema";
import ArrayMap from "../lib/ArrayMap";
import {EntityType} from "../@types/entity";
import {EntityPlurals} from "../entities";

/**
 * Find the matching entity in the redux store.
 *
 * @param {EntityPlurals} entityName
 * @param {uuid} id
 * @returns {<T> | null}
 */
function find<T extends EntityType>(entityName: EntityPlurals, id: uuid): T | null {
    // Never a match if no id
    if (!id) return null;

    // Find entity exists in the store
    const table = (Object.hasOwnProperty.call(store.getState(), entityName))
                  // @ts-ignore
                  ? store.getState()[entityName] as ArrayMap<T>
                  : null;

    // Return the match (only one)
    if (table) return table.get(id) as T;

    // Bail if no such entity, but not before issuing an error
    else {
        return null;
    }
}

export function findAll<T extends EntityType>(entityName: EntityPlurals): ArrayMap<T> {
    return store.getState()[entityName] || new ArrayMap<T>(entityName);
}

export default find;